// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"App_spinnerContainer__I-yI0","spinner":"App_spinner__bIZjU","spin":"App_spin__Lgf8x","alerticon":"App_alerticon__lXqhx","modaltext":"App_modaltext__+lWY8"};